import { render, staticRenderFns } from "./Fee.vue?vue&type=template&id=74bd7493"
import script from "./Fee.vue?vue&type=script&lang=js"
export * from "./Fee.vue?vue&type=script&lang=js"
import style0 from "./Fee.vue?vue&type=style&index=0&id=74bd7493&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports